import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

const PromoWrapper = styled.div`
  width: 100%;
  height: 30px;
  background-color: var(--color-secondary);
  color: var(--color-body-text);
  font-family: var(--font-paragraphs);
  display: flex;
  align-items: center;
  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    height: 40px;
  }
`;
const InnerWrapper = styled.div`
  max-width: 1920px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  width: 100%;
`;
const TextDiv = styled.div`
  width: 100%;
  display: flex;
  text-align: center;
  padding-left: 10px;
  p {
    margin: 0;
    font-size: 0.8rem;
    font-family: var(--font-paragraphs);
  }
`;
const CloseIcon = styled(FontAwesomeIcon)`
  color: var(--color-body-text);
`;
const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  margin-right: 5px;
`;

const PromoBanner = ({ promoEnabled, promoText }) => {
  const [isHidden, setHidden] = useState(true);
  function hidePromoBanner() {
    setHidden(true);
    localStorage.setItem("promoBanner", isHidden);
    const date = new Date();
    date.setDate(date.getDate() + 14);
    localStorage.setItem("promo-banner-expire", date);
  }
  useEffect(() => {
    const date = localStorage.getItem("promo-banner-expire");
    const newDate = new Date();
    if (date < newDate) {
      setHidden(false);
    } else {
      setHidden(true);
    }
  });
  return (
    <>
      {promoEnabled && !isHidden && (
        <PromoWrapper>
          <InnerWrapper>
            <TextDiv
              dangerouslySetInnerHTML={{
                __html: promoText,
              }}
            />
            <CloseButton onClick={hidePromoBanner}>
              <CloseIcon icon={faTimes} />
            </CloseButton>
          </InnerWrapper>
        </PromoWrapper>
      )}
    </>
  );
};

export default PromoBanner;

PromoBanner.propTypes = {
  promoEnabled: PropTypes.bool,
  promoText: PropTypes.string,
};
